import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';

const BASE = ADMIN_REST_API_BASE_URL;

export interface AuditLogEntry {
  id: number;
  actor: string;
  timestamp: string;
  targetType: string | null;
  targetId: string | null;
  action: string;
  reason: string | null;
  beforeValue: string | null;
  afterValue: string | null;
}

export interface AuditLogPage {
  content: AuditLogEntry[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const getAuditLog = (
  page: number,
  size: number,
  actor?: string,
  targetType?: string,
  action?: string,
) => {
  const params: Record<string, string | number> = { page, size };
  if (actor) params.actor = actor;
  if (targetType) params.targetType = targetType;
  if (action) params.action = action;
  return apiClient.get<AuditLogPage>(`${BASE}/audit-log`, { params });
};
